/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_TotalInputs */

const vi_order_total = /** @type {(inputs: Order_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng tiền`)
};

/**

* @param {Order_TotalInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_total = /** @type {((inputs?: Order_TotalInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_TotalInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_total(inputs)
});